import React from "react";
import { Link, useParams } from "react-router-dom";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { ACCOUNT, ORDER_HISTORY } from "../../../constants";
import { ItemTitle, Divider } from "../../../commons/elements";
import EventDetails from "../../../commons/event-details";

const propTypes = {
  orderDetails: PropTypes.shape({
    id: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    paid: PropTypes.number.isRequired,
    refunded: PropTypes.number,
    type: PropTypes.string.isRequired,
    dateRefunded: PropTypes.string,
    events: PropTypes.arrayOf(
      PropTypes.shape({
        startTime: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      })
    )
  })
};

const defaultProps = {
  orderDetails: {}
};

function OrderDetails(props) {
  const { orderDetails } = props;
  const params = useParams();
  const isRefund = !!orderDetails?.refunded && !!orderDetails?.dateRefunded;

  let amtPaid = null;
  if (orderDetails?.paid) {
    amtPaid =
      orderDetails.paid === 0
        ? "Complimentary"
        : `$${(orderDetails.paid / 100).toFixed(2)}`;
  }

  let amtRefunded = null;
  if (orderDetails?.refunded) {
    amtRefunded = `$${(orderDetails.refunded / 100).toFixed(2)}`;
  }

  return (
    <div className="order-details-container">
      <div className="back-order-history mb-4">
        <Link to={`/${params.shortName}/${ACCOUNT}/${ORDER_HISTORY}`}>
          &lt; Order History
        </Link>
      </div>
      <div className="order-name mb-4">
        <ItemTitle title={orderDetails?.name} />
      </div>
      <div className="order-details d-flex flex-column mt-4">
        <div className="order-info">
          <div className="info-title">Product Type:</div>
          <div className="info-value">{orderDetails?.type}</div>
        </div>
        <div className="order-info">
          <div className="info-title">Order ID:</div>
          <div className="info-value">{orderDetails?.id}</div>
        </div>
        <div className="order-info">
          <div className="info-title">Date Purchased:</div>
          <div className="info-value">
            <Moment format="MMM. DD, YYYY">{orderDetails?.date}</Moment>
          </div>
        </div>
        <div className="order-info">
          <div className="info-title">Amount Paid:</div>
          <div className="info-value">{amtPaid}</div>
        </div>
        {isRefund && (
          <>
            <div className="order-info">
              <div className="info-title">Date Refunded:</div>
              <div className="info-value">
                <Moment format="MMM. DD, YYYY">
                  {orderDetails?.dateRefunded}
                </Moment>
              </div>
            </div>
            <div className="order-info">
              <div className="info-title">Amount Refunded:</div>
              <div className="info-value">
                {amtRefunded} <br />
              </div>
            </div>
            <i className="mt-2">Refunds take up to 72 hours to process.</i>
          </>
        )}
      </div>
      {!isRefund && (
        <>
          <Divider />
          <div className="d-flex flex-column pt-4">
            <span className="passport-includes mb-4">Product Includes:</span>
            <div className="product-packages-list">
              {orderDetails?.events?.map((evt) => (
                <EventDetails
                  key={evt.id}
                  startTime={evt.startTime}
                  title={evt.title}
                  id={evt.id}
                  clientShortName={evt.clientShortName}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

OrderDetails.propTypes = propTypes;
OrderDetails.defaultProps = defaultProps;

export default OrderDetails;
